export const aciReserved = {
    iconName: 'reserved',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M15.788 9.74c.194.178.209.479.032.674l-2.487 2.74a.804.804 0 01-.294.208.853.853 0 01-.694-.018.797.797 0 01-.282-.226l-.775-.957a.476.476 0 11.74-.6l.69.853 2.397-2.64a.476.476 0 01.673-.033z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M20.053 7.115a.476.476 0 00-.46-.353H5.624a.476.476 0 00-.46.599l2.54 9.524a.476.476 0 00.46.354h13.97a.476.476 0 00.46-.6l-2.54-9.524zm-.826.6l2.286 8.571H8.53L6.244 7.714h12.983z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.748 6.778a.476.476 0 00-.583.337l-2.54 9.525a.476.476 0 00.46.599h2.54a.476.476 0 100-.953h-1.92l2.38-8.925a.476.476 0 00-.337-.583z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
